(function () {
  const initPartnersSlider = () => {
    document.querySelectorAll(".partners-slider__swiper").forEach((el) => {
      if (el.classList.contains("swiper-initialized")) return;
      const slidesDesktop = Number(el.getAttribute("data-slides-desktop")) || 8;
      const slidesTablet = Number(el.getAttribute("data-slides-tablet")) || 6;
      const slidesMobile = Number(el.getAttribute("data-slides-mobile")) || 4;

      const isAutoplay = String(el.getAttribute("data-autoplay")) === "true";
      const delaySec = Number(el.getAttribute("data-delay")) || 0;
      const speedSec = Number(el.getAttribute("data-speed")) || 0.8;

      new Swiper(el, {
        watchSlidesProgress: true,
        speed: Math.round(speedSec * 1000),
        loop: false,
        allowTouchMove: true,
        spaceBetween: 32,
        slidesPerView: slidesDesktop,
        autoplay: isAutoplay
          ? {
              delay: Math.round(delaySec * 1000),
              disableOnInteraction: false,
            }
          : false,
        breakpoints: {
          0: {
            slidesPerView: slidesMobile,
            spaceBetween: 12,
          },
          576: {
            slidesPerView: slidesTablet,
            spaceBetween: 16,
          },
          990: {
            slidesPerView: slidesDesktop,
            spaceBetween: 24,
          },
          1360: {
            slidesPerView: slidesDesktop,
            spaceBetween: 32,
          },
        },
      });
    });
  };

  document.addEventListener("DOMContentLoaded", initPartnersSlider);
  document.addEventListener("shopify:section:load", initPartnersSlider);
})();
